import { Typography } from "@/frontend/shared/ui/Typography/Typography";
import styles from "./CompanySection.module.scss";
import { NormalButton } from "@/frontend/shared/ui/Button";
import { Input } from "@/frontend/shared/ui/Input";
import { useEffect, useState } from "react";
import { Textarea } from "@/frontend/shared/ui/Textarea/Textarea";
import { SelectionDropdown } from "@/frontend/shared/ui/SelectionDropdown";
import {
  currencyOptions,
  dateOptions,
  investorRoundOptions,
  locationOptions,
  regionOptions,
  stageOptions,
  yearOptions
} from "../const/const";
import { DropdownInput } from "@/frontend/shared/ui/DropdownInput";
import { CurrencyInput } from "@/frontend/shared/ui/CurrencyInput/CurrencyInput";
import { UploadLogo } from "@/frontend/shared/ui/UploadLogo/UploadLogo";
import { EditIcon, LinkedinIcon, TrashIcon, UserIcon } from "@/frontend/shared/assets/icons";
import clsx from "clsx";
import { TFormData, TInvestor } from "../types/companySectionTypes";

type TCompanySection = {
  setNewData: (formData: TFormData) => void;
  createCompanyHandler: () => void;
  isLoading: boolean;
};

export function CompanySection({ setNewData, createCompanyHandler, isLoading }: TCompanySection) {
  const [formData, setFormData] = useState({
    companyLogo: "",
    name: "",
    headline: "",
    description: "",
    website: "",
    domain: "",
    selectedYearValue: "",
    isYearSelectorOpen: false,
    selectedRegionValue: "",
    isRegionSelectorOpen: false,
    selectedLocationValue: "",
    isLocationSelectorOpen: false,
    teamSizeValue: 0,
    facebookValue: "",
    linkedInValue: "",
    angelListValue: "",
    githubValue: "",
    instagramValue: "",
    xTwitterValue: "",
    productHuntValue: "",
    selectedCurrencyValue: "",
    isCurrencySelectorOpen: false,
    totalFundingValue: 0,
    lastValuationValue: 0,
    industriesValue: "",
    tagsValue: "",
    tamValue: 0,
    samValue: 0,
    somValue: 0,
    targetMarketsValue: "",
    investors: [
      {
        image: "",
        name: "Investor 1",
        investorRound: "Seed",
        investorStage: "Pre-seed",
        investorAmount: 100000,
        investorValuation: 1000000
      }
    ] as TInvestor[],
    investorImage: "",
    investorName: "",
    investorRound: "",
    investorStage: "",
    investorAmount: 0,
    investorValuation: 0,
    isStageSelectorOpen: false,
    selectedStageValue: "",
    isInvestorRoundSelectorOpen: false,
    selectedInvestorRoundValue: "",
    totalRaisedValue: 0,
    postMoneyValuationValue: 0,
    selectedTypeValue: "",
    isTypeSelectorOpen: false,
    selectedDate: "",
    isDateSelectorOpen: false,
    foundersData: {
      founders: [
        {
          image: "",
          firstName: "Kevin",
          lastName: "James",
          title: "CEO",
          bio: "ex Google, Facebook, Uber. Oxford University 11111111111111",
          linkedIn: "linkedin.com/in/kevin-james"
        }
      ],
      founderImage: "",
      founderFirstName: "",
      founderLastName: "",
      founderTitle: "",
      founderBio: "",
      founderLinkedIn: ""
    }
  });

  const [errorMessages, setErrorMessages] = useState({
    founderError: "",
    investorError: ""
  });

  const [openedCard, setOpenedCard] = useState<"founder" | "investor" | null>(null);

  useEffect(() => {
    setNewData(formData);
  });

  function addFounder() {
    if (!formData.foundersData.founderFirstName.trim() || !formData.foundersData.founderLastName.trim()) {
      setErrorMessages((prev) => ({ ...prev, founderError: "First name and last name are required." }));
    } else {
      setFormData((prev) => ({
        ...prev,
        foundersData: {
          ...prev.foundersData,
          founders: [
            ...prev.foundersData.founders,
            {
              image: prev.foundersData.founderImage,
              firstName: prev.foundersData.founderFirstName,
              lastName: prev.foundersData.founderLastName,
              title: prev.foundersData.founderTitle,
              bio: prev.foundersData.founderBio,
              linkedIn: prev.foundersData.founderLinkedIn
            }
          ],
          founderImage: "",
          founderFirstName: "",
          founderLastName: "",
          founderTitle: "",
          founderBio: "",
          founderLinkedIn: ""
        }
      }));
      setErrorMessages((prev) => ({ ...prev, founderError: "" }));
      setOpenedCard(null);
    }
  }

  function editInvestor(index: number) {
    const investor = formData.investors[index];
    setFormData((prev) => ({
      ...prev,
      investorImage: investor.image,
      investorName: investor.name,
      selectedInvestorRoundValue: investor.investorRound,
      investorStage: investor.investorStage,
      investorAmount: investor.investorAmount,
      investorValuation: investor.investorValuation,
      editingInvestorIndex: index
    }));
    setOpenedCard("investor");
  }

  function removeInvestor(index: number) {
    setFormData((prev) => ({
      ...prev,
      investors: prev.investors.filter((_, i) => i !== index)
    }));
  }

  function removeFounder(founderIndex: number) {
    setFormData((prev) => ({
      ...prev,
      foundersData: {
        ...prev.foundersData,
        founders: prev.foundersData.founders.filter((_, index) => index !== founderIndex),
        founderImage: "",
        founderFirstName: "",
        founderLastName: "",
        founderTitle: "",
        founderBio: "",
        founderLinkedIn: ""
      }
    }));
  }
  function editFounder(index: number) {
    const founder = formData.foundersData.founders[index];
    setFormData((prev) => ({
      ...prev,
      foundersData: {
        ...prev.foundersData,
        founderImage: founder.image,
        founderFirstName: founder.firstName,
        founderLastName: founder.lastName,
        founderTitle: founder.title,
        founderBio: founder.bio,
        founderLinkedIn: founder.linkedIn,
        editingIndex: index
      }
    }));
  }

  function addInvestor() {
    if (!formData.investorName.trim()) {
      setErrorMessages((prev) => ({ ...prev, investorError: "Investor name is required." }));
    } else {
      setFormData((prev) => ({
        ...prev,
        investors: [
          ...prev.investors,
          {
            image: prev.investorImage,
            name: prev.investorName,
            investorRound: prev.selectedInvestorRoundValue,
            investorStage: prev.investorStage,
            investorAmount: prev.investorAmount,
            investorValuation: prev.investorValuation
          }
        ],
        investorImage: "",
        investorName: "",
        selectedInvestorRoundValue: "",
        investorStage: "",
        investorAmount: 0,
        investorValuation: 0
      }));
      setErrorMessages((prev) => ({ ...prev, investorError: "" }));
      setOpenedCard(null);
    }
  }

  return (
    <div className={styles.container}>
      <Typography variant="heading-6" color="greyscale900" className={styles.sectionTitle}>
        Company
      </Typography>
      <div className={styles.contentContainer}>
        <div>
          <Typography variant="label-4" color="greyscale700" className={styles.blockTitle}>
            Logo
          </Typography>
          <UploadLogo
            image={formData.companyLogo}
            onUpload={(e) => setFormData((prev) => ({ ...prev, companyLogo: e }))}
            onRemove={() => setFormData((prev) => ({ ...prev, companyLogo: "" }))}
            text={formData.companyLogo ? "Change Logo" : "Upload Logo"}
          />
        </div>
        <div className={styles.nameBlock}>
          <Typography variant="label-4" color="greyscale700" className={styles.blockTitle}>
            Name*
          </Typography>
          <Input
            inputSize="large"
            value={formData.name}
            onChange={(e) => setFormData((prev) => ({ ...prev, name: e.target.value }))}
            placeholder="Company name"
          />
        </div>
        <div className={styles.headlineBlock}>
          <Typography variant="label-4" color="greyscale700" className={styles.blockTitle}>
            Headline*
          </Typography>
          <Textarea
            className={styles.headlineTextarea}
            value={formData.headline}
            onChange={(e) => setFormData((prev) => ({ ...prev, headline: e.target.value }))}
            placeholder="ie. Uber for Private Jets"
          />
        </div>
        <div className={styles.headlineBlock}>
          <Typography variant="label-4" color="greyscale700" className={styles.blockTitle}>
            Description*
          </Typography>
          <Textarea
            value={formData.description}
            onChange={(e) => setFormData((prev) => ({ ...prev, description: e.target.value }))}
            placeholder="Describe company"
          />
        </div>
        <div className={styles.foundersBlock}>
          <Typography variant="label-4" color="greyscale700" className={styles.blockTitle}>
            Founders*
          </Typography>
          <div className={styles.foundersList}>
            {formData.foundersData.founders.map((founder, index) => (
              <div key={index} className={styles.founderBlock}>
                <div className={styles.founderInfoSubBlock}>
                  {founder.image ? (
                    <img src={founder.image} alt="founder" className={styles.founderImage} />
                  ) : (
                    <div className={styles.placeholderIconContainer}>
                      <UserIcon />
                    </div>
                  )}
                  <div className={styles.founderInfoBlock}>
                    <div className={styles.fullNameContainer}>
                      <Typography variant="label-4" color="greyscale900" className={styles.founderName}>
                        {founder.firstName} {founder.lastName}
                      </Typography>
                      {founder.linkedIn && <LinkedinIcon className={styles.founderLinkedInIcon} />}
                    </div>
                    <Typography variant="body-2" color="greyscale800" className={styles.founderTitle}>
                      {founder.title}
                    </Typography>
                    <Typography variant="body-2" color="greyscale700" className={styles.founderBio}>
                      {founder.bio}
                    </Typography>
                  </div>
                </div>
                <div className={styles.founderActionIcons}>
                  <EditIcon
                    onClick={() => {
                      editFounder(index);
                      setOpenedCard("founder");
                    }}
                  />
                  <TrashIcon onClick={() => removeFounder(index)} />
                </div>
              </div>
            ))}
          </div>
          <div className={clsx(styles.addFounderBlock, openedCard === "founder" && styles.visibleFounderBlock)}>
            <UploadLogo
              onRemove={() =>
                setFormData((prev) => ({ ...prev, foundersData: { ...prev.foundersData, founderImage: "" } }))
              }
              onUpload={(e) =>
                setFormData((prev) => ({ ...prev, foundersData: { ...prev.foundersData, founderImage: e } }))
              }
              image={formData.foundersData.founderImage}
              text={formData.foundersData.founderImage ? "Change Logo" : "Upload Logo"}
            />
            <div className={styles.founderNameBlock}>
              <div className={styles.founderFirstNameBlock}>
                <Typography variant="label-4" color="greyscale700" className={styles.blockTitle}>
                  First name
                </Typography>
                <Input
                  inputSize="large"
                  value={formData.foundersData.founderFirstName}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      foundersData: { ...prev.foundersData, founderFirstName: e.target.value }
                    }))
                  }
                  placeholder="First name"
                  error={errorMessages.founderError}
                />
              </div>
              <div className={styles.founderLastNameBlock}>
                <Typography variant="label-4" color="greyscale700" className={styles.blockTitle}>
                  Last name
                </Typography>
                <Input
                  inputSize="large"
                  value={formData.foundersData.founderLastName}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      foundersData: { ...prev.foundersData, founderLastName: e.target.value }
                    }))
                  }
                  placeholder="Last name"
                  error={errorMessages.founderError}
                />
              </div>
            </div>
            <div className={styles.founderTitleBlock}>
              <Typography variant="label-4" color="greyscale700" className={styles.blockTitle}>
                Title
              </Typography>
              <Input
                inputSize="large"
                value={formData.foundersData.founderTitle}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    foundersData: { ...prev.foundersData, founderTitle: e.target.value }
                  }))
                }
                placeholder="Title"
              />
            </div>
            <div className={styles.founderBioBlock}>
              <Typography variant="label-4" color="greyscale700" className={styles.blockTitle}>
                Bio
              </Typography>
              <Textarea
                value={formData.foundersData.founderBio}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    foundersData: { ...prev.foundersData, founderBio: e.target.value }
                  }))
                }
                placeholder="Bio"
              />
            </div>
            <div className={styles.founderLinkedInBlock}>
              <Typography variant="label-4" color="greyscale700" className={styles.blockTitle}>
                LinkedIn
              </Typography>
              <Input
                inputSize="large"
                value={formData.foundersData.founderLinkedIn}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    foundersData: { ...prev.foundersData, founderLinkedIn: e.target.value }
                  }))
                }
                placeholder="LinkedIn"
              />
            </div>
            <div className={styles.buttonsContainer}>
              <NormalButton size="medium" onClick={addFounder}>
                Add founder
              </NormalButton>
              <NormalButton size="medium" variant="tertiary" color="greyscale600" onClick={() => setOpenedCard(null)}>
                Cancel
              </NormalButton>
            </div>
          </div>
          <NormalButton
            variant="secondary"
            color="greyscale800"
            leftIcon
            size="medium"
            onClick={() => {
              if (openedCard !== "founder") {
                setOpenedCard("founder");
              } else {
                setOpenedCard(null);
              }
            }}
            className={styles.addFounderMainBtn}
          >
            Add founder
          </NormalButton>
        </div>
        <div className={styles.emailContainer}>
          <div className={styles.websiteBlock}>
            <Typography variant="label-4" color="greyscale700" className={styles.blockTitle}>
              Website*
            </Typography>
            <Input
              value={formData.website}
              onChange={(e) => setFormData((prev) => ({ ...prev, website: e.target.value }))}
              inputSize="large"
              placeholder="Company name"
            />
          </div>
          <div className={styles.emailDomainBlock}>
            <Typography variant="label-4" color="greyscale700" className={styles.blockTitle}>
              Email Domain*
            </Typography>
            <Input
              inputSize="large"
              value={formData.domain}
              onChange={(e) => setFormData((prev) => ({ ...prev, domain: e.target.value }))}
              placeholder="Company name"
              description="Specify your company domain to limit account claims to company email addresses."
            />
          </div>
        </div>
        <div className={styles.yearFoundedBlock}>
          <Typography variant="label-4" color="greyscale700" className={styles.blockTitle}>
            Year founded*
          </Typography>
          <SelectionDropdown
            isOpen={formData.isYearSelectorOpen}
            onFocus={() => setFormData((prev) => ({ ...prev, isYearSelectorOpen: true }))}
            options={yearOptions}
            value={formData.selectedYearValue}
            onChange={(e) => setFormData((prev) => ({ ...prev, selectedYearValue: e as string }))}
            onClose={() => setFormData((prev) => ({ ...prev, isYearSelectorOpen: false }))}
            inputSize="large"
          />
        </div>
        <div className={styles.regionBlock}>
          <Typography variant="label-4" color="greyscale700" className={styles.blockTitle}>
            Region*
          </Typography>
          <DropdownInput
            isOpen={
              regionOptions.length > 0 && formData.selectedRegionValue.length > 0 && formData.isRegionSelectorOpen
            }
            options={regionOptions}
            value={formData.selectedRegionValue}
            selected={formData.selectedRegionValue}
            onChange={(e) => {
              setFormData((prev) => ({ ...prev, selectedRegionValue: e.target.value }));
              setFormData((prev) => ({ ...prev, isRegionSelectorOpen: true }));
            }}
            onClose={() => setFormData((prev) => ({ ...prev, isRegionSelectorOpen: false }))}
            onSelect={(e) => {
              setFormData((prev) => ({ ...prev, selectedRegionValue: e }));
            }}
            inputSize="large"
          />
        </div>
        <div className={styles.yearFoundedBlock}>
          <Typography variant="label-4" color="greyscale700" className={styles.blockTitle}>
            Location*
          </Typography>
          <DropdownInput
            isOpen={
              locationOptions.length > 0 && formData.selectedLocationValue.length > 0 && formData.isLocationSelectorOpen
            }
            options={locationOptions}
            value={formData.selectedLocationValue}
            selected={formData.selectedLocationValue}
            onChange={(e) => {
              setFormData((prev) => ({ ...prev, selectedLocationValue: e.target.value, isLocationSelectorOpen: true }));
            }}
            onClose={() => setFormData((prev) => ({ ...prev, isLocationSelectorOpen: false }))}
            onSelect={(e) => {
              setFormData((prev) => ({ ...prev, selectedLocationValue: e }));
            }}
            inputSize="large"
          />
        </div>
        <div className={styles.regionBlock}>
          <Typography variant="label-4" color="greyscale700" className={styles.blockTitle}>
            Team size
          </Typography>
          <Input
            value={formData.teamSizeValue}
            onChange={(e) => setFormData((prev) => ({ ...prev, teamSizeValue: Number(e.target.value) }))}
          />
        </div>
        <div className={styles.socialMediaBlock}>
          <Typography variant="label-4" color="greyscale700" className={styles.blockTitle}>
            Social media
          </Typography>
          <div className={styles.socialMediaSubBlock}>
            <Input
              value={formData.facebookValue}
              onChange={(e) => setFormData((prev) => ({ ...prev, facebookValue: e.target.value }))}
              placeholder="Facebook"
            />
            <Input
              value={formData.linkedInValue}
              onChange={(e) => setFormData((prev) => ({ ...prev, linkedInValue: e.target.value }))}
              placeholder="LinkedIn"
            />
            <Input
              value={formData.angelListValue}
              onChange={(e) => setFormData((prev) => ({ ...prev, angelListValue: e.target.value }))}
              placeholder="AngelList"
            />
            <Input
              value={formData.githubValue}
              onChange={(e) => setFormData((prev) => ({ ...prev, githubValue: e.target.value }))}
              placeholder="Github"
            />
            <Input
              value={formData.instagramValue}
              onChange={(e) => setFormData((prev) => ({ ...prev, instagramValue: e.target.value }))}
              placeholder="Instagram"
            />
            <Input
              value={formData.xTwitterValue}
              onChange={(e) => setFormData((prev) => ({ ...prev, xTwitterValue: e.target.value }))}
              placeholder="X (Twitter)"
            />
            <Input
              value={formData.productHuntValue}
              onChange={(e) => setFormData((prev) => ({ ...prev, productHuntValue: e.target.value }))}
              placeholder="Product Hunt"
            />
          </div>
        </div>
        <div className={styles.currencySubBlock}>
          <div>
            <Typography variant="label-4" color="greyscale700" className={styles.blockTitle}>
              Currency
            </Typography>
            <SelectionDropdown
              value={formData.selectedCurrencyValue}
              onChange={(e) => setFormData((prev) => ({ ...prev, selectedCurrencyValue: e as string }))}
              isOpen={formData.isCurrencySelectorOpen}
              onFocus={() => setFormData((prev) => ({ ...prev, isCurrencySelectorOpen: !prev.isCurrencySelectorOpen }))}
              onClose={() => setFormData((prev) => ({ ...prev, isCurrencySelectorOpen: false }))}
              options={currencyOptions}
              inputSize="large"
              className={styles.currencyLabel}
            />
          </div>
          <div className={styles.totalFundingSubBlock}>
            <Typography variant="label-4" color="greyscale700" className={styles.blockTitle}>
              Total funding
            </Typography>
            <Input
              value={formData.totalFundingValue}
              onChange={(e) => setFormData((prev) => ({ ...prev, totalFundingValue: Number(e.target.value) }))}
              className={styles.totalFundingValue}
            />
          </div>
        </div>
        <div>
          <Typography variant="label-4" color="greyscale700" className={styles.blockTitle}>
            Last valuation
          </Typography>
          <CurrencyInput
            value={formData.lastValuationValue}
            onChange={(e) => setFormData((prev) => ({ ...prev, lastValuationValue: Number(e) }))}
            placeholder="Enter last valuation"
          />
        </div>
      </div>
      <Typography variant="label-4" color="greyscale700" className={styles.blockTitle}>
        Financing rounds
      </Typography>
      <div className={styles.bottomContentBlock}>
        <div className={styles.financialRoundsBlock}>
          <div>
            <Typography variant="label-4" color="greyscale700" className={styles.blockTitle}>
              Stage
            </Typography>
            <SelectionDropdown
              isOpen={formData.isStageSelectorOpen}
              onFocus={() => setFormData((prev) => ({ ...prev, isStageSelectorOpen: true }))}
              value={formData.selectedStageValue}
              onChange={(e) => setFormData((prev) => ({ ...prev, selectedStageValue: e as string }))}
              onClose={() => setFormData((prev) => ({ ...prev, isStageSelectorOpen: false }))}
              options={stageOptions}
              inputSize="large"
            />
          </div>
          <div>
            <Typography variant="label-4" color="greyscale700" className={styles.blockTitle}>
              Total raised
            </Typography>
            <CurrencyInput
              value={formData.totalRaisedValue}
              onChange={(e) => setFormData((prev) => ({ ...prev, totalRaisedValue: Number(e) }))}
              placeholder="Enter total raised amount"
            />
          </div>
          <div>
            <Typography variant="label-4" color="greyscale700" className={styles.blockTitle}>
              Valuation (post-money)
            </Typography>
            <CurrencyInput
              value={formData.postMoneyValuationValue}
              onChange={(e) => setFormData((prev) => ({ ...prev, postMoneyValuationValue: Number(e) }))}
              placeholder="Enter post-money valuation"
            />
          </div>
          <div>
            <Typography variant="label-4" color="greyscale700" className={styles.blockTitle}>
              Investors
            </Typography>
            {formData.investors.map((investor, index) => {
              return (
                <div key={index} className={styles.singleInvestorContainer}>
                  <div className={styles.investorInfoContainer}>
                    {investor.image ? (
                      <img src={investor.image} alt="investor" className={styles.investorImage} />
                    ) : (
                      <div className={styles.placeholderIconContainer}>
                        <UserIcon />
                      </div>
                    )}
                    <div className={styles.investorNameContainer}>
                      <Typography variant="label-4" color="greyscale700" className={styles.investorName}>
                        {investor.name}
                      </Typography>
                      <Typography variant="label-4" color="greyscale700" className={styles.investorRound}>
                        {investor.investorRound}
                      </Typography>
                    </div>
                  </div>
                  <div className={styles.investorIcons}>
                    <EditIcon onClick={() => editInvestor(index)} />
                    <TrashIcon onClick={() => removeInvestor(index)} />
                  </div>
                </div>
              );
            })}
          </div>
          <div className={clsx(styles.addInvestorBlock, styles.visibleAddInvestorBlock)}>
            <UploadLogo
              image={formData.investorImage}
              onUpload={(e) => setFormData((prev) => ({ ...prev, investorImage: e }))}
              onRemove={() => setFormData((prev) => ({ ...prev, investorImage: "" }))}
              text={formData.companyLogo ? "Change Logo" : "Upload Logo"}
            />
            <div className={styles.addInvestorsSubBlock}>
              <div>
                <Typography variant="label-4" color="greyscale700" className={styles.blockTitle}>
                  Investor name
                </Typography>
                <Input
                  value={formData.investorName}
                  onChange={(e) => setFormData((prev) => ({ ...prev, investorName: e.target.value }))}
                  placeholder="Investor name"
                  error={errorMessages.investorError}
                />
              </div>
              <div>
                <Typography variant="label-4" color="greyscale700" className={styles.blockTitle}>
                  Type
                </Typography>
                <SelectionDropdown
                  isOpen={formData.isInvestorRoundSelectorOpen}
                  onFocus={() => setFormData((prev) => ({ ...prev, isInvestorRoundSelectorOpen: true }))}
                  value={formData.selectedInvestorRoundValue}
                  onChange={(e) => setFormData((prev) => ({ ...prev, selectedInvestorRoundValue: e as string }))}
                  onClose={() => setFormData((prev) => ({ ...prev, isInvestorRoundSelectorOpen: false }))}
                  options={investorRoundOptions}
                  inputSize="large"
                />
              </div>
            </div>
            <div className={styles.addInvestorBtnBlock}>
              <NormalButton size="medium" onClick={addInvestor}>
                Add investor
              </NormalButton>
              <NormalButton size="medium" color="greyscale600" variant="tertiary">
                Cancel
              </NormalButton>
            </div>
          </div>
          <div>
            <Typography variant="label-4" color="greyscale700" className={styles.blockTitle}>
              Date
            </Typography>
            <SelectionDropdown
              isOpen={formData.isDateSelectorOpen}
              onFocus={() => setFormData((prev) => ({ ...prev, isDateSelectorOpen: true }))}
              value={formData.selectedDate}
              onChange={(e) => setFormData((prev) => ({ ...prev, selectedDate: e as string }))}
              onClose={() => setFormData((prev) => ({ ...prev, isDateSelectorOpen: false }))}
              options={dateOptions}
              inputSize="large"
            />
          </div>
          <div className={styles.addStageBtnsBlock}>
            <NormalButton size="medium">Add Stage</NormalButton>
            <NormalButton size="medium" color="greyscale600" variant="tertiary">
              Cancel
            </NormalButton>
          </div>
        </div>
        <NormalButton
          size="medium"
          leftIcon
          variant="secondary"
          color="greyscale800"
          className={styles.addFinancingRoundBtn}
        >
          Add financing round
        </NormalButton>
        <div>
          <Typography variant="label-4" color="greyscale700" className={styles.blockTitle}>
            Industries*
          </Typography>
          <Input
            value={formData.industriesValue}
            onChange={(e) => setFormData((prev) => ({ ...prev, industriesValue: e.target.value }))}
            placeholder="ie. AI, Hadrware, Climate"
          />
        </div>
        <div>
          <Typography variant="label-4" color="greyscale700" className={styles.blockTitle}>
            Tags
          </Typography>
          <Input
            value={formData.tagsValue}
            onChange={(e) => setFormData((prev) => ({ ...prev, tagsValue: e.target.value }))}
            placeholder="ie. Public, Computer Vision,  IOT, "
          />
        </div>
        <div>
          <Typography variant="label-4" color="greyscale700" className={styles.blockTitle}>
            Market
          </Typography>
          <div className={styles.marketInputSubBlock}>
            <CurrencyInput
              value={formData.tamValue}
              onChange={(e) => setFormData((prev) => ({ ...prev, tamValue: Number(e) }))}
              placeholder="TAM"
            />
            <CurrencyInput
              value={formData.samValue}
              onChange={(e) => setFormData((prev) => ({ ...prev, samValue: Number(e) }))}
              placeholder="SAM"
            />
            <CurrencyInput
              value={formData.somValue}
              onChange={(e) => setFormData((prev) => ({ ...prev, somValue: Number(e) }))}
              placeholder="SOM"
            />
          </div>
          <Input
            value={formData.targetMarketsValue}
            onChange={(e) => setFormData((prev) => ({ ...prev, targetMarketsValue: e.target.value }))}
            placeholder="Target markets"
            className={styles.targetMarketsInput}
          />
        </div>
        <NormalButton
          size="large"
          className={styles.proceedBtn}
          onClick={() => {
            createCompanyHandler();
          }}
          isDisabled={isLoading}
        >
          Proceed
        </NormalButton>
      </div>
    </div>
  );
}
